/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const INDEX_URL = "/api/dashboard";
export function index() {
    return apiService.post(INDEX_URL, true, {});
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/dashboard.ts